import { useState } from "react";

// styles
import styles from "./RadioBlock.module.scss";

// comonents
import { Heading, Radio } from "components/LibraryComponents/Components";

export default function RadioBlock() {
  const [value, setValue] = useState<string>("option-1");

  return (
    <div className={styles["radio-block-root"]}>
      <Heading title="Radio Button" />

      <div style={{ marginTop: 24 }} />

      <div className={styles["group"]}>
        <div className={styles["toggle-col"]}>
          <span className={styles["label"]}>Default</span>
          <Radio
            id="option-1"
            name="option-1"
            label="Option 1"
            value={value}
            checked={value === "option-1"}
            onChange={() => setValue("option-1")}
          />
          <Radio
            id="option-2"
            name="option-2"
            label="Option 2"
            value={value}
            checked={value === "option-2"}
            onChange={() => setValue("option-2")}
          />
        </div>
      </div>
    </div>
  );
}
